/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.filtersModule')

/**
 * An Angular filter that abbreviates a number by magnitude.
 */
.filter('magnitude', function() {

  /**
   * Rounds a Number to a specified precision.
   * Similar to Number.toFixed, but returns a Number rather than a String.  This results in no trailing zeros
   * or even a decimal point if unneeded when the return value is converted to a String.
   * @see http://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-in-javascript
   */
  function roundToPrecision(number, precision) {
    return +(Math.round(+(number + 'e+' + precision)) + 'e-' + precision);
  }

    // FUTURE: i18n (tricky in a filter because angular-translate is async)
  var bulbUnitPrefixes = {
    'count': ['', 'K', 'M', 'B', 'T'],  /* K for 1000, then Million, Billion, Trillion */
    'metric': ['', 'k', 'M', 'G', 'T']  /* kilo, Mega, Giga, Tera */
  };

  /**
   * An Angular filter that formats a number by a factor and precision, appending a unit magnitude prefix.
   *
   * @param {Number} number  The number to format.
   * @param {{precision?: Number, unitPrefixes?: String|String[], factor?: Number}} [options]  Formatting options:
   *    factor: Base factor to divide by to determine the unitPrefixes index (default is 1000).
   *    precision: Maximum number of digits after the decimal point (default is 1).
   *    unitPrefixes: 'metric' (default), 'count', or an Array of unit prefixes for 0-999, 1000-999999, etc.
   *
   * @returns {String} The formatted number with magnitude unit prefix.
   */
    function magnitudeFilter(number, options) {
    options = options || {};
    var factor = options.factor || 1000;
    var precision = options.precision !== undefined ? options.precision : 1;
    var unitPrefixes = options.unitPrefixes || 'metric';
    if (!Array.isArray(unitPrefixes)) {
      if (!bulbUnitPrefixes.hasOwnProperty(unitPrefixes)) {
        console.error(
          '[magnitude filter] Unknown options.unitPrefixes \'' + unitPrefixes + '\': using \'metric\'');
        unitPrefixes = 'metric';
      }
      unitPrefixes = bulbUnitPrefixes[unitPrefixes];
    }

    var magnitude = number;
    var isNegative = number < 0;
    var signFactor = 1;
    if (isNegative) {
      magnitude = Math.abs(number);
      signFactor = -1;
    }
    var unitIndex = 0;
    if (magnitude >= factor) {
      var roundedMagnitude;
      do {
        ++unitIndex;
        magnitude /= factor;
        roundedMagnitude = roundToPrecision(magnitude, precision);
      } while (roundedMagnitude >= factor && unitIndex + 1 < unitPrefixes.length);
      magnitude = roundedMagnitude;
    } else {
      magnitude = roundToPrecision(magnitude, precision);
    }
    magnitude *= signFactor;
    return magnitude + unitPrefixes[unitIndex];
  }

    return magnitudeFilter;
});
